import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance, { axiosFormInstance } from "../../../api/axiosInstance";
import { endpoints } from "../../../api/endpoints";

export const getHiredCandidatesReportClientApi = createAsyncThunk(
  "Client/getHiredCandidatesReportClientApi",
  async (userData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.getlistofreportsforclient,
        userData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const getCandidatesReportForClient = createAsyncThunk(
  "Client/getCandidatesReportForClient",
  async (userData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.getrejectedcandidatelist,
        userData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const getHiredCandidatesReportClientApiSlice = createSlice({
  name: "getHiredCandidatesReportClientApiSlice",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHiredCandidatesReportClientApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(getHiredCandidatesReportClientApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(getHiredCandidatesReportClientApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export default getHiredCandidatesReportClientApiSlice.reducer;
